import { initializeRecord } from "../../helpers/helpers";
import { genomeOptions } from "../../constants";

const g = Object.keys(genomeOptions);

const initialState = {
    position: initializeRecord(g, -10),
    selection: initializeRecord(g, [])
}

export const changePointerPosition = (newValue) => {
    return {
        type: "pointer/pointerMove",
        payload: newValue
    };
}

export const changePointerSelection = (newValue) => {
    return {
        type: "pointer/pointerSelection",
        payload: newValue
    };
}

export const pointerReducer = (state = initialState, action) => {
    switch(action.type) {
        case "pointer/pointerMove":
            return {
                ...state,
                position: {
                    ...state["position"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "pointer/pointerSelection":
            return {
                ...state,
                selection: {
                    ...state["selection"],
                    [action.payload.key]: action.payload.value
                }
            };
        default:
            return state;
    };
}